export default __webpack_public_path__ + "static/Hero_Image_Dark-973a66d9fad8f57889c3a44af81251ba.png";